import { Typography } from '@mui/material';
import React, { FC, memo, ReactNode } from 'react';
import { FlexColumn } from '../../basic-flex/flex-column';

interface Props {
	title: string;
	children: ReactNode;
}

export const EquipmentInfoSection: FC<Props> = memo(({ title, children }) => (
	<FlexColumn sx={{ gap: 0.5 }}>
		<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
			{title}
		</Typography>
		{children}
	</FlexColumn>
));
